
import React from 'react';

type ReactMarkdownComponentProps = {
  children: React.ReactNode;
  className?: string;
};

export const EnhancedBlockquote: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <blockquote className="my-4 ml-3 pl-4 border-l-4 border-primary/50 bg-primary/5 py-3 pr-4 rounded-r-lg italic text-muted-foreground text-sm">
    {children}
  </blockquote>
);
